import {
  AlertSpot,
  BagHandleSpot,
  CartSpot,
  CheckMark,
  CheckMarkV2,
  InfoSpot,
  InfoSpotV2,
  LockSpot,
  MobileSpot,
  PhoneSpot,
  ShieldLockSpot,
  ShieldSpot,
  StampPercentSpot,
  StepOneSpot,
  StepTwoSpot,
  TrackingNewSpot,
  TrackingSpot,
  TrophyNewSpot,
  TrophySpot,
} from '@/components/Common/Spots';

export const icons = {
  ALERT: AlertSpot,
  BAG_HANDLE: BagHandleSpot,
  CART: CartSpot,
  CHECK_MARK: CheckMark,
  CHECK_MARK_V2: CheckMarkV2,
  INFO_SPOT: InfoSpot,
  INFO_SPOT_V2: InfoSpotV2,
  LOCK: LockSpot,
  MOBILE_SPOT: MobileSpot,
  PHONE: PhoneSpot,
  SHIELD: ShieldSpot,
  SHIELD_LOCK: ShieldLockSpot,
  STAMP_PERCENT: StampPercentSpot,
  STEP_ONE_SPOT: StepOneSpot,
  STEP_TWO_SPOT: StepTwoSpot,
  TRACK: TrackingSpot,
  TRACK_NEW: TrackingNewSpot,
  TROPHY: TrophySpot,
  TROPHY_NEW: TrophyNewSpot,
} as const;

export type IconName = keyof typeof icons;
